/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.09.2016.
 */

import ShowcaseFavorites from './showcase-favorites';

export default ShowcaseFavorites;



// WEBPACK FOOTER //
// ./src/containers/ShowcaseFavorites/index.js